import '@booking-portal/polyfills/container-queries';
import '@booking-portal/assets/scss/tailwind.scss';
import '@booking-portal/assets/scss/style.scss';
import '@booking-portal/assets/scss/forms.scss';
import { router } from '@booking-portal/router';
import { clearLocalStorageKeys } from '@booking-portal/utils/local-storage-cleanup';
import { setupMsw } from 'shared/msw';
import { logHiringMessage, logVersion } from 'shared/utils';
import { createApp } from 'vue';

import App from './App.vue';
import { setupDayjs } from './plugins/dayjs-plugin';
import { setupI18n } from './plugins/i18n-plugin';
import { setupNotifications } from './plugins/notifications-plugin';
import { setupPinia } from './plugins/pinia-plugin';
import { setupRouter } from './plugins/router-plugin';
import { setupSentry } from './plugins/sentry-plugin';
import { setupTouchEvents } from './plugins/touch-events-plugin';
import { setupUseHead } from './plugins/use-head-plugin';
import { setupVirtualScroller } from './plugins/virtual-scroller-plugin';
import { setupVueMotion } from './plugins/vue-motion-plugin';
import { setupVueQuery } from './plugins/vue-query-plugin';

if (window !== window.parent) {
  const message =
    'Embedding the Kinnovis booking or customer portal via iFrame is not supported. Reach out to our support team in case you have any questions.';
  document.getElementsByTagName('body')[0].innerHTML =
    `<h2 class="text-2xl text-center mt-4">${message}</h2>`;
  throw new Error(message);
}

/**
 * Created one main init function. This one can easily be changed to an async function later on if we - for instance - want to integrate MSW here, which has an async initializer
 */
async function initApp() {
  logVersion();
  logHiringMessage();
  const app = createApp(App);

  setupRouter(app);
  setupI18n(app);
  setupDayjs();
  setupPinia(app);
  setupVueQuery(app);
  setupVueMotion(app);
  setupUseHead(app);
  setupTouchEvents(app);
  setupNotifications(app);
  setupVirtualScroller(app);
  setupSentry(app, router);

  // Removed deprecated local storage keys
  clearLocalStorageKeys([
    'booking-flow-basket-id',
    'booking-flow-basket-id-location',
  ]);

  await setupMsw({
    app,
    handlers: () => import('@booking-portal/msw/handlers'),
  });

  app.mount('#app');
}

initApp();
